<!-- GlobalLoginModal.vue -->
<template>
	<!-- ElementUI 全局登录弹窗，手机号+验证码  -->
	<div class="flex-betweenStart">
		<el-dialog :visible.sync="visible" append-to-body width="760px" :close-on-click-modal="false" @close="handleClose">
			<div class="flex-betweenCenter">
				<div class="login-img">
					<img src="@/assets/images/login.png" alt="">
				</div>
				<div class="login-right ">
					<div class="font20 flex-betweenCenter margin-bottom20 cursor-active">
						<div class="width50p flex-center height40" :class="activeName==1?'tabActive':''" @click="handleClick(1)">
							手机登录</div>
						<div class="width50p flex-center height40" :class="activeName==2?'tabActive':''" @click="handleClick(2)">
							二维码登录</div>
					</div>

					<div class="right-height" v-if="activeName==1">
						<el-form :model="loginForm" :rules="loginRules" ref="loginForm" label-width="0">
							<!-- 手机号输入框 -->
							<el-form-item prop="phone">

								<!-- prefix-icon="el-icon-phone" -->
								<el-input v-model="loginForm.phone" placeholder="请输入手机号" maxlength="11" @input="formatPhone">
									<img slot="prefix" class="width15 height15 margin-left5 margin-top12"
										src="@/assets/images/icon-phone.png" alt="" />
								</el-input>
							</el-form-item>

							<!-- 验证码输入框 + 获取验证码按钮 -->
							<el-form-item prop="code">
								<el-row :gutter="10">
									<el-col :span="15">
										<el-input v-model="loginForm.code" placeholder="请输入验证码" maxlength="6"
											prefix-icon="el-icon-lock"></el-input>
									</el-col>
									<el-col :span="9">
										<el-button :disabled="codeDisabled" @click="getVerifyCode" style="width: 100%;">
											{{ codeText }}
										</el-button>
									</el-col>
								</el-row>
							</el-form-item>
						</el-form>
						<!-- 弹窗底部按钮  -->
						<div slot="footer" class="dialog-footer">
							<el-button type="primary" class="width100p border-radius6 bg-blue border-blue" @click="handleLogin"
								:loading="loginLoading">注册/登录</el-button>
							<div class="flex-startCenter margin-top15 readAll" @click="readAll">
								<img class="width18 height18 margin-right5" v-if="readed1 && readed2" src="@/assets/images/checked.png"
									alt="">
								<img class="width18 height18 margin-right5" v-if="!readed1 || !readed2" src="@/assets/images/check.png"
									alt="">
								<div class="flex-startCenter margin-left5">
									我已阅读并同意
									<div class="color-blue weight550" @click.stop="agreeShow2=true">《用户协议》</div>
									和
									<div class="color-blue weight550" @click.stop="agreeShow1=true">《隐私协议》</div>
								</div>
							</div>
						</div>
					</div>

					<div v-else class="flex-columnCenter right-height">
						<div id="login_container"></div>
						<div class="scenImg">
							<img class="scenImg" :src="codeImg" alt="" />
						</div>
						<div class="flex-center font20 margin-top20 margin-bottom10">
							打开 <span class="color-blue font24">微信扫一扫</span>
						</div>
						<!-- <div class="font17">快速登录/注册</div> -->
						<!-- <div class="font12 color-grey9 margin-top15" v-if="pollingCount > 0">
							等待扫码... ({{ pollingCount }}s)
						</div>
						<div class="flex-center margin-top15">
							<el-button type="text" @click="refreshQrCode" :loading="qrLoading">
								<i class="el-icon-refresh-right"></i> 刷新二维码
							</el-button>
						</div> -->
					</div>
				</div>
			</div>

			<el-dialog :visible="agreeShow1" width="1000px" append-to-body @close="agreeShow1=false">
				<div class="padding20 flex-columnCenter">
					<div class="font20">隐私协议</div>
					<div class="agree-wrap" v-html="agreement1"></div>
					<el-button type="primary" class="width300 border-radius6 bg-blue border-blue" @click="know(1)">知道了</el-button>
				</div>
			</el-dialog>

			<el-dialog :visible="agreeShow2" width="1000px" append-to-body @close="agreeShow2=false">
				<div class="padding20 flex-columnCenter">
					<div class="font20">用户协议</div>
					<div class="padding20 flex-columnCenter">
						<div class="agree-wrap" v-html="agreement2"></div>
						<el-button type="primary" class="width300 border-radius6 bg-blue border-blue"
							@click="know()">知道了</el-button>
					</div>
				</div>
			</el-dialog>
		</el-dialog>

		<!-- <GlobalProvince :visible="provnceVisible" @confirm="provncConfirm" @close="provnceVisible=false"></GlobalProvince> -->

	</div>
</template>

<script>
	import bus from '@/utils/bus'
	import {
		sendCode,
		phoneLogin,
		agreement,
		privacy,
		getCode,
		getQrResult, // 轮询扫码结果的接口
		qrLogin // 二维码登录确认接口
	} from '@/api/user'

	export default {
		name: 'GlobalLoginModal',
		data() {
			return {
				activeName: 1,
				provnceVisible: false,
				visible: false, // 弹窗显示状态
				loginLoading: false, // 登录按钮加载状态
				codeDisabled: false, // 获取验证码按钮禁用状态
				codeText: '获取验证码', // 验证码按钮文本
				countdown: 60, // 倒计时秒数
				// 登录表单
				loginForm: {
					phone: '',
					code: ''
				},
				codeImg: '',
				qrKey: '', // 二维码唯一标识，用于轮询
				pollingTimer: null, // 轮询定时器
				pollingCount: 0, // 轮询倒计时显示
				qrLoading: false, // 刷新二维码loading
				// 表单校验规则
				loginRules: {
					phone: [{
							required: true,
							message: '请输入手机号',
							trigger: 'blur'
						},
						{
							pattern: /^1[3-9]\d{9}$/,
							message: '请输入正确的手机号',
							trigger: 'blur'
						}
					],
					code: [{
							required: true,
							message: '请输入验证码',
							trigger: 'blur'
						},
						// {
						// 	pattern: /^\d{6}$/,
						// 	message: '请输入6位数字验证码',
						// 	trigger: 'blur'
						// }
					],
				},
				readed1: false,
				readed2: false,
				agreement1: '',
				agreement2: '',
				agreeShow1: false,
				agreeShow2: false,
			}
		},
		created() {
			// 监听显示登录弹窗的全局事件
			bus.$on('showLoginModal', () => {
				this.visible = true
				this.getInfo()
				this.$refs.loginForm?.resetFields() // 重置表单
				// 重置二维码相关状态
				this.resetQrState()
			})
		},
		beforeDestroy() {
			// 销毁事件监听，避免内存泄漏
			bus.$off('showLoginModal')
			// 清除倒计时定时器
			clearInterval(this.timer)
			// 清除轮询定时器
			this.stopPolling()
		},
		methods: {
			handleClick(val) {
				this.activeName = val
				if (val === 2) {
					this.getCodeImg()
				} else {
					// 切换到手机登录时停止轮询
					this.stopPolling()
				}
			},
			// 获取二维码
			getCodeImg() {
				// var DDNS_resolution = encodeURIComponent("https://admin.kaoyaai.com/wechatCode");
				// var wx = new WxLogin({
				//   id: 'login_container',
				//   self_redirect: false,
				//   appid: "wxccc812cf81782996",
				//   scope: "snsapi_login",
				//   redirect_uri: DDNS_resolution,
				//   href:'https://api.upere.cn/image/login.css'
				// })

				this.qrLoading = true
				getCode().then(res => {
					this.codeImg = res.data.qr_code
					this.qrKey = res.data.scene
					// 获取到二维码后开始轮询
					this.startPolling()
				}).catch(err => {
					this.codeImg = ''
					this.$message.error('获取二维码失败，请重试')
				}).finally(() => {
					this.qrLoading = false
				})
			},

			// 刷新二维码
			refreshQrCode() {
				this.stopPolling()
				this.getCodeImg()
			},
			// 开始轮询扫码结果
			startPolling() {
				// 先停止已有轮询
				this.stopPolling()

				let pollCount = 0
				const maxPollCount = 120 // 最多轮询120次（约2分钟）

				this.pollingTimer = setInterval(() => {
					pollCount++
					this.pollingCount = 60 - Math.floor(pollCount / 2) // 显示剩余时间

					// 超时未扫码，停止轮询并提示
					if (pollCount >= maxPollCount) {
						this.stopPolling()
						this.$message.warning('二维码已过期，请刷新重试')
						this.pollingCount = 0
						return
					}

					// 调用轮询接口
					this.checkQrStatus()
				}, 5000) // 每秒轮询一次
			},
			// 检查二维码状态
			async checkQrStatus() {
				if (!this.qrKey) return
				try {
					// 调用后端接口查询扫码状态
					const res = await getQrResult({
						scene: this.qrKey
					})
					const status = res.data.status
					console.error('轮询成功:', res.data)
				} catch (error) {
					console.error('轮询失败:', error)
				}
			},
			// 二维码登录成功处理
			handleQrLoginSuccess(data) {
				const token = data.token
				const userInfo = data.user_info

				if (token) {
					// 存储token
					localStorage.setItem('token', token)
					localStorage.setItem('userInfo', JSON.stringify(userInfo))

					this.$message.success('登录成功')
					this.visible = false

					// 重置状态
					this.resetQrState()
					this.$refs.loginForm?.resetFields()

					// 触发登录成功事件
					bus.$emit('loginSuccess', userInfo)
				} else {
					this.$message.error('登录失败，请重试')
					this.getCodeImg() // 刷新二维码
				}
			},
			// 停止轮询
			stopPolling() {
				if (this.pollingTimer) {
					clearInterval(this.pollingTimer)
					this.pollingTimer = null
				}
				this.pollingCount = 0
			},

			// 重置二维码相关状态
			resetQrState() {
				this.stopPolling()
				this.codeImg = ''
				this.qrKey = ''
				this.qrLoading = false
			},
			getInfo() {
				agreement().then(res => {
					this.agreement1 = res.data
				}).catch(err => {
					this.agreement1 = ''
				})
				privacy().then(res => {
					this.agreement2 = res.data
				}).catch(err => {
					this.agreement2 = ''
				})
			},
			// 格式化手机号
			formatPhone() {
				this.loginForm.phone = this.loginForm.phone.replace(/\D/g, '')
			},
			// 关闭弹窗
			handleClose() {
				this.visible = false
				this.$refs.loginForm?.resetFields()
				// 重置验证码按钮状态
				this.codeDisabled = false
				this.codeText = '获取验证码'
				clearInterval(this.timer)
				this.stopPolling()
				this.resetQrState()
			},

			// 获取验证码
			getVerifyCode() {
				// 先校验手机号
				this.$refs.loginForm.validateField('phone', (err) => {
					if (!err) {
						// 禁用按钮，开始倒计时
						this.codeDisabled = true
						this.timer = setInterval(() => {
							this.countdown--
							this.codeText = `${this.countdown}s后重新获取`
							if (this.countdown <= 0) {
								clearInterval(this.timer)
								this.codeText = '获取验证码'
								this.codeDisabled = false
								this.countdown = 60
							}
						}, 1000)

						sendCode({
							phone: this.loginForm.phone
						}).then(res => {
							this.$message.success('验证码已发送')
							this.loginForm.code = res.data
						}).catch(err => {
							this.$message.error(err.errmsg)
						})
					} else {
						this.$message.error('请输入正确的手机号')
					}
				})
			},

			// 手机验证码登录逻辑
			handleLogin() {

				// 表单整体校验
				this.$refs.loginForm.validate((valid) => {
					if (valid) {
						if (!this.readed1 || !this.readed2) {
							this.$message.warning('请先同意相关协议')
							return
						}
						this.loginLoading = true
						phoneLogin(this.loginForm).then(res => {
							// this.$message.success('登录成功')
							// this.provnceVisible = true
							this.visible = false

							// 重置表单和验证码状态
							this.$refs.loginForm.resetFields()
							this.codeDisabled = false
							this.codeText = '获取验证码'
							clearInterval(this.timer)
							this.countdown = 60
							// 触发登录成功全局事件，更新头部用户名
							bus.$emit('loginSuccess', res.data)
							// this.$router.go(0)
						}).catch(err => {
							// this.$message.error('catch' + err)
						}).finally(res => {
							this.loginLoading = false
						})
					} else {
						// this.$message.error('请完善登录信息')
						return false
					}
				})
			},
			readAll() {
				this.readed1 = !this.readed1
				this.readed2 = this.readed1
			},
			know(val) {
				if (val) {
					this.readed1 = true
					this.agreeShow1 = false
				} else {
					this.readed2 = true
					this.agreeShow2 = false
				}
			},
			provncConfirm(name, id) {
				this.provnceVisible = false
				this.visible = false
			},
		}
	}
</script>

<style scoped lang="scss">
	.login-img {
		width: 307px;
		height: 467px;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.readAll {
		cursor: pointer;
	}

	.login-right {
		width: 400px;
		padding: 0 30px;

		.right-height {
			height: 300px;
		}

		.tabActive {
			position: relative;
			color: #28b05e;

			&:before {
				content: '';
				position: absolute;
				width: 35px;
				height: 3px;
				border-radius: 2px;
				background: #28b05e;
				bottom: 0;
				left: 40%;
			}
		}

	}


	.dialog-footer {
		margin-top: 68px;
	}

	/* 调整输入框图标颜色 */
	::v-deep {
		.el-dialog {
			border-radius: 12px;

			&__header,
			&__body {
				padding: 0;
			}
		}
	}


	.el-input__prefix {
		color: #c0c4cc;
	}

	.agree-wrap {
		max-height: 500px;
		overflow-y: auto;
		margin-bottom: 20px;
	}

	.scenImg {
		width: 214px;
		height: 214px;
	}
</style>
